import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _bulkDeleteRsvpsByFilterRequest = {};
var _bulkDeleteRsvpsByFilterResponse = {};
var _bulkUpdateRsvpsRequest = { rsvps: '_bulkUpdateRsvpsRequestMaskedRsvp' };
var _bulkUpdateRsvpsRequestMaskedRsvp = {
    fieldMask: 'google.protobuf.FieldMask',
    rsvp: '_rsvp',
};
var _bulkUpdateRsvpsResponse = {
    results: '_bulkUpdateRsvpsResponseBulkRsvpResult',
};
var _bulkUpdateRsvpsResponseBulkRsvpResult = { rsvp: '_rsvp' };
var _cancelRsvpGuestsCheckInRequest = {};
var _cancelRsvpGuestsCheckInResponse = { rsvp: '_rsvp' };
var _checkInDetails = { checkInDate: 'google.protobuf.Timestamp' };
var _checkInRsvpGuestsRequest = {};
var _checkInRsvpGuestsResponse = { rsvp: '_rsvp' };
var _commonAddress = { geocode: '_commonAddressLocation' };
var _commonAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _countRsvpsRequest = {};
var _countRsvpsResponse = {};
var _createRsvpRequest = { rsvp: '_rsvp' };
var _createRsvpResponse = { rsvp: '_rsvp' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deleteRsvpRequest = {};
var _deleteRsvpResponse = {};
var _formattedAddress = { address: '_commonAddress' };
var _formResponse = { inputValues: '_inputValue' };
var _getRsvpRequest = {};
var _getRsvpResponse = { rsvp: '_rsvp' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _guest = { checkInDetails: '_checkInDetails' };
var _guestList = { guests: '_guest' };
var _inputValue = {
    number: 'google.protobuf.DoubleValue',
    dateTime: 'google.protobuf.Timestamp',
    address: '_formattedAddress',
};
var _listCurrentRsvpsRequest = {};
var _listCurrentRsvpsResponse = { rsvps: '_rsvp' };
var _listRsvpSummaryRequest = {};
var _listRsvpSummaryResponse = {};
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryRsvpsRequest = {};
var _queryRsvpsResponse = { rsvps: '_rsvp' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _results = { results: 'Map#_nestedResultValue' };
var _rsvp = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    form: '_formResponse',
    guestList: '_guestList',
};
var _scalarResult = { value: 'DOUBLE' };
var _searchRsvpsRequest = { search: '_cursorSearch' };
var _searchRsvpsResponse = {
    rsvps: '_rsvp',
    aggregationData: '_aggregationData',
};
var _updateRsvpRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    rsvp: '_rsvp',
};
var _updateRsvpResponse = { rsvp: '_rsvp' };
function resolveWixEventsRsvpsV2RsvpManagementUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-rsvps',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v2/rsvps',
                destPath: '/v2/rsvps',
            },
            {
                srcPath: '/events/v2/bulk/rsvps',
                destPath: '/v2/bulk/rsvps',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-rsvps',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-rsvps',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of RSVPs that match the specified search query and optionally performs aggregations on the data queried.
 *
 * To learn about working with _search_, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 */
export function searchRsvps(payload) {
    var _a = serializer(_searchRsvpsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchRsvpsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _groupByValueResults: _groupByValueResults,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _rsvp: _rsvp,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchRsvps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.SearchRsvps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchRsvps.fromReq = fromReq;
    __searchRsvps.__isAmbassador = true;
    return __searchRsvps;
}
/**
 * Retrieves a list of RSVPs, with the specified paging, filtering, and sorting.
 *
 * Query RSVPs runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order.
 * - `paging.limit` is `100`.
 * - `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see [RSVP v2: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/events/rsvp-v2/filter-and-sort).
 * To learn about working with Query methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 *
 * > **Note:** This method is quite slow. Use the following filter pairs for the most optimal speed:
 * > - `eventId` and `status`
 * > - `eventId` and `fullyCheckedIn`
 * > - `eventId` and `memberId`
 * > - `eventId` and `contactId`
 * > - `eventId` and `createdDate`
 */
export function queryRsvps(payload) {
    var _a = serializer(_queryRsvpsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRsvpsResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __queryRsvps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.QueryRsvps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRsvps.fromReq = fromReq;
    __queryRsvps.__isAmbassador = true;
    return __queryRsvps;
}
/** Counts RSVPs with the specified filtering and searching. */
export function countRsvps(payload) {
    var _a = serializer(_countRsvpsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countRsvpsResponse, {}).fromJSON;
    function __countRsvps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.CountRsvps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countRsvps.fromReq = fromReq;
    __countRsvps.__isAmbassador = true;
    return __countRsvps;
}
/** Retrieves an RSVP by ID. */
export function getRsvp(payload) {
    var _a = serializer(_getRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRsvpResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __getRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'GET',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.GetRsvp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/{rsvpId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRsvp.fromReq = fromReq;
    __getRsvp.__isAmbassador = true;
    return __getRsvp;
}
/**
 * Creates an RSVP.
 *
 * To create anRSVP with multiple guests, you have to specify the `additionalGuests` and `guestNames` fields.
 */
export function createRsvp(payload) {
    var _a = serializer(_createRsvpRequest, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRsvpResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __createRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.CreateRsvp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRsvp.fromReq = fromReq;
    __createRsvp.__isAmbassador = true;
    return __createRsvp;
}
/**
 * Updates RSVP.
 *
 * Each time the RSVP is updated, `revision` increments by 1. The existing `revision` must be specified when updating the RSVP. This ensures you're working with the latest RSVP and prevents unintended overwrites.
 */
export function updateRsvp(payload) {
    var _a = serializer(_updateRsvpRequest, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRsvpResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __updateRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'PATCH',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.UpdateRsvp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/{rsvp.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateRsvp.fromReq = fromReq;
    __updateRsvp.__isAmbassador = true;
    return __updateRsvp;
}
/** Deletes an RSVP. */
export function deleteRsvp(payload) {
    var _a = serializer(_deleteRsvpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRsvpResponse, {}).fromJSON;
    function __deleteRsvp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'DELETE',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.DeleteRsvp',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/{rsvpId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteRsvp.fromReq = fromReq;
    __deleteRsvp.__isAmbassador = true;
    return __deleteRsvp;
}
/**
 * Updates multiple RSVPs.
 *
 * You can update up to 100 RSVPs per request.
 */
export function bulkUpdateRsvps(payload) {
    var _a = serializer(_bulkUpdateRsvpsRequest, {
        _bulkUpdateRsvpsRequestMaskedRsvp: _bulkUpdateRsvpsRequestMaskedRsvp,
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateRsvpsResponse, {
        _bulkUpdateRsvpsResponseBulkRsvpResult: _bulkUpdateRsvpsResponseBulkRsvpResult,
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __bulkUpdateRsvps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'PATCH',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.BulkUpdateRsvps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/bulk/rsvps/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateRsvps.fromReq = fromReq;
    __bulkUpdateRsvps.__isAmbassador = true;
    return __bulkUpdateRsvps;
}
/** Deletes multiple RSVPs. */
export function bulkDeleteRsvpsByFilter(payload) {
    var _a = serializer(_bulkDeleteRsvpsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteRsvpsByFilterResponse, {}).fromJSON;
    function __bulkDeleteRsvpsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.BulkDeleteRsvpsByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/bulk/rsvps/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteRsvpsByFilter.fromReq = fromReq;
    __bulkDeleteRsvpsByFilter.__isAmbassador = true;
    return __bulkDeleteRsvpsByFilter;
}
/**
 * Checks in RSVP guests.
 *
 * You can check in up to 11 guests per request.
 */
export function checkInRsvpGuests(payload) {
    var _a = serializer(_checkInRsvpGuestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkInRsvpGuestsResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __checkInRsvpGuests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.CheckInRsvpGuests',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/{rsvpId}/check-in',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkInRsvpGuests.fromReq = fromReq;
    __checkInRsvpGuests.__isAmbassador = true;
    return __checkInRsvpGuests;
}
/**
 * Cancels the check-in of RSVP guests.
 *
 * If the request body is empty, cancels all check-ins from the RSVP. After the cancellation, the `guests.checkInDate` value becomes empty.
 *
 * You can cancel the check-in of up to 11 guests per request.
 */
export function cancelRsvpGuestsCheckIn(payload) {
    var _a = serializer(_cancelRsvpGuestsCheckInRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelRsvpGuestsCheckInResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __cancelRsvpGuestsCheckIn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'POST',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.CancelRsvpGuestsCheckIn',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/{rsvpId}/cancel-check-in',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelRsvpGuestsCheckIn.fromReq = fromReq;
    __cancelRsvpGuestsCheckIn.__isAmbassador = true;
    return __cancelRsvpGuestsCheckIn;
}
/** Retrieves an RSVP summary. */
export function listRsvpSummary(payload) {
    var _a = serializer(_listRsvpSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRsvpSummaryResponse, {}).fromJSON;
    function __listRsvpSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'GET',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.ListRsvpSummary',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/summaries',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRsvpSummary.fromReq = fromReq;
    __listRsvpSummary.__isAmbassador = true;
    return __listRsvpSummary;
}
/** Lists RSVPs for the authenticated member across specified events. */
export function listCurrentRsvps(payload) {
    var _a = serializer(_listCurrentRsvpsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCurrentRsvpsResponse, {
        _checkInDetails: _checkInDetails,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _guestList: _guestList,
        _inputValue: _inputValue,
        _rsvp: _rsvp,
    }).fromJSON;
    function __listCurrentRsvps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.rsvp',
            method: 'GET',
            methodFqn: 'wix.events.rsvps.v2.RsvpManagement.ListCurrentRsvps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsRsvpsV2RsvpManagementUrl({
                protoPath: '/v2/rsvps/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCurrentRsvps.fromReq = fromReq;
    __listCurrentRsvps.__isAmbassador = true;
    return __listCurrentRsvps;
}
//# sourceMappingURL=http.impl.js.map